import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex justify-start align-center" }
const _hoisted_2 = {
  key: 0,
  class: "app---logo"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "pl-2 font-weight-bold app--theme-color"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "app-setting-tab app---setting-tab",
  style: {"overflow-x":"auto","flex-shrink":"0"}
}
const _hoisted_7 = { class: "text-body-2 pl-2 white-space-pre-wrap" }
const _hoisted_8 = { class: "text-body-2 pl-2 text-right" }
const _hoisted_9 = { class: "text-body-2 pl-2 white-space-pre-wrap" }
const _hoisted_10 = { class: "text-body-2 pl-2 text-right" }
const _hoisted_11 = { class: "text-body-2 pl-2 white-space-pre-wrap" }
const _hoisted_12 = { class: "text-body-2 pl-2 text-right" }
const _hoisted_13 = { class: "text-body-2 pl-2 white-space-pre-wrap" }
const _hoisted_14 = { class: "text-body-2 pl-2 text-right" }
const _hoisted_15 = { class: "pl-6 py-2 app-header-menu d-flex align-center" }
const _hoisted_16 = {
  key: 1,
  class: "pl-3"
}
const _hoisted_17 = { class: "text-header-menu-email font-size-14 font-weight-400" }
const _hoisted_18 = { class: "text-header-menu-name font-size-12 font-weight-400" }
const _hoisted_19 = { class: "pl-4" }
const _hoisted_20 = { class: "d-flex align-center text-header-menu--item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "px-2 py-0 mx-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { class: "d-flex justify-start align-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "d-flex justify-start align-center"
            }, {
              default: _withCtx(() => [
                (_ctx.appLogo && _ctx.appLogo.base64)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createElementVNode("img", {
                        src: _ctx.appLogo.base64,
                        cover: "fill"
                      }, null, 8, _hoisted_3)
                    ]))
                  : (_openBlock(), _createBlock(_component_app_icon, {
                      key: 1,
                      icon: "app-logo",
                      class: "d-flex justify-start align-center"
                    }))
              ]),
              _: 1
            })
          ]),
          (_ctx.appName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/",
                  style: {"text-decoration":"none","color":"inherit"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.appName), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
        default: _withCtx(() => [
          (_ctx.isEnableBellNotification)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_v_menu, {
                  location: "bottom",
                  modelValue: _ctx.isOpenNotifications,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isOpenNotifications) = $event)),
                  "close-on-content-click": false
                }, {
                  activator: _withCtx(({ props }) => [
                    (_ctx.notificationCount)
                      ? (_openBlock(), _createBlock(_component_v_badge, {
                          key: 0,
                          content: _ctx.notificationCount,
                          color: "#D32F2F",
                          "offset-x": "-3",
                          max: "20"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(props)), {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-bell")
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : (_openBlock(), _createBlock(_component_v_icon, _normalizeProps(_mergeProps({ key: 1 }, props)), {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-bell")
                          ]),
                          _: 2
                        }, 1040))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      "min-width": "600",
                      "max-height": "700",
                      class: "d-flex flex-column"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isEnableOTA)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_v_tabs, {
                                modelValue: _ctx.tab,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
                                "align-with-title": "",
                                class: "justify"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item) => {
                                    return (_openBlock(), _createBlock(_component_v_tab, {
                                      style: _normalizeStyle(`width: ${100 / _ctx.tabs.length}%`),
                                      key: `tab-item-${item.value}`,
                                      value: item.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(item.title), 1),
                                        (item.notificationCount)
                                          ? (_openBlock(), _createBlock(_component_v_badge, {
                                              key: 0,
                                              content: item.notificationCount,
                                              class: "ml-4 mb-1",
                                              color: "#D32F2F",
                                              max: "20"
                                            }, null, 8, ["content"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["style", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_window, {
                          modelValue: _ctx.tab,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
                          style: {"flex":"1 1 auto","overflow-y":"auto","min-height":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { value: "esim" }, {
                              default: _withCtx(() => [
                                (_ctx.eSimNotificationItems.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_list, {
                                      key: 0,
                                      lines: "three"
                                    }, {
                                      default: _withCtx(() => [
                                        (!_ctx.isEnableOTA && !_ctx.isEnableIoTSAFE)
                                          ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                              key: 0,
                                              lines: "three",
                                              class: "text-h6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("Notifications")), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eSimNotificationItems, (item) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: `esim-${item.date}`,
                                            border: "",
                                            link: "",
                                            class: "pa-0",
                                            onClick: ($event: any) => (_ctx.notificationClickHandler(item.to))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_sheet, {
                                                width: "100%",
                                                class: "pa-4",
                                                style: _normalizeStyle(_ctx.getSheetStyle(item.body, item.to))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.title)), 1),
                                                  _createElementVNode("p", _hoisted_7, _toDisplayString(item.body), 1),
                                                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.showDate(item.date, "YYYY-MM-DD HH:mm:ss")), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["style"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_subtitle, { class: "text-h6" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("NoNotifications")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: "sim" }, {
                              default: _withCtx(() => [
                                (_ctx.simNotificationItems.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_list, {
                                      key: 0,
                                      lines: "three"
                                    }, {
                                      default: _withCtx(() => [
                                        (!_ctx.isEnableOTA && !_ctx.isEnableIoTSAFE)
                                          ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                              key: 0,
                                              lines: "three",
                                              class: "text-h6"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("Notifications")), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simNotificationItems, (item) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: `sim-${item.date}`,
                                            border: "",
                                            link: "",
                                            class: "pa-0",
                                            onClick: ($event: any) => (_ctx.notificationClickHandler(item.to))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_sheet, {
                                                width: "100%",
                                                class: "pa-4",
                                                style: _normalizeStyle(_ctx.getSheetStyle(item.body, item.to))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.title)), 1),
                                                  _createElementVNode("p", _hoisted_9, _toDisplayString(item.body), 1),
                                                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.showDate(item.date, "YYYY-MM-DD HH:mm:ss")), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["style"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_subtitle, { class: "text-h6" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("NoNotifications")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: "ota" }, {
                              default: _withCtx(() => [
                                (_ctx.otaNotificationItems.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_list, {
                                      key: 0,
                                      lines: "three"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otaNotificationItems, (item) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: `ota-${item.date}`,
                                            border: "",
                                            link: "",
                                            class: "pa-0",
                                            onClick: ($event: any) => (_ctx.notificationClickHandler(item.to))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_sheet, {
                                                width: "100%",
                                                class: "pa-4",
                                                style: _normalizeStyle(_ctx.getSheetStyle(item.body, item.to))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.title)), 1),
                                                  _createElementVNode("p", _hoisted_11, _toDisplayString(item.body), 1),
                                                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.showDate(item.date, "YYYY-MM-DD HH:mm:ss")), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["style"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_subtitle, { class: "text-h6" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("NoNotifications")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: "iotsafe" }, {
                              default: _withCtx(() => [
                                (_ctx.iotsafeNotificationItems.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_list, {
                                      key: 0,
                                      lines: "three"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iotsafeNotificationItems, (item) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: `iotsafe-${item.date}`,
                                            border: "",
                                            link: "",
                                            class: "pa-0",
                                            onClick: ($event: any) => (_ctx.notificationClickHandler(item.to))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_sheet, {
                                                width: "100%",
                                                class: "pa-4",
                                                style: _normalizeStyle(_ctx.getSheetStyle(item.body, item.to))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.title)), 1),
                                                  _createElementVNode("p", _hoisted_13, _toDisplayString(item.body), 1),
                                                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.showDate(item.date, "YYYY-MM-DD HH:mm:ss")), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["style"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_subtitle, { class: "text-h6" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("NoNotifications")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_v_menu, {
              "location-strategy": "connected",
              "scroll-strategy": "close",
              class: "app-header-menu-list"
            }, {
              activator: _withCtx(({ props }) => [
                _createElementVNode("div", _mergeProps(props, { class: "d-flex align-center cursor-pointer" }), [
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-account-circle")
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.email == _ctx.$t('NoEmail') || _ctx.name == _ctx.$t('NoName'))
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        class: "ml-3 loading",
                        size: 25,
                        indeterminate: ""
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.email), 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.name), 1)
                      ])),
                  _createElementVNode("div", _hoisted_19, [
                    (props['aria-expanded'] == 'true')
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-menu-up")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-menu-down")
                          ]),
                          _: 1
                        }))
                  ])
                ], 16)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, ([title, icon, to, target], i) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: i,
                        to: title != _ctx.$t('OfficialDocs') ? to : undefined,
                        href: title == _ctx.$t('OfficialDocs') ? to : undefined,
                        target: target
                      }, {
                        prepend: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_app_icon, { icon: icon }, null, 8, ["icon"])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, {
                            textContent: _toDisplayString(title)
                          }, null, 8, ["textContent"])
                        ]),
                        _: 2
                      }, 1032, ["to", "href", "target"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}